import { useEffect } from "react";
import { Typography } from "@mui/material";

import Grid from "@mui/material/Grid2";

function Information(props) {
  const { facility = {}, selectedZone = {}, zonesMap = {} } = props;
  const {
    abbreviation,
    category,
    floor,
    name,
    parentId,
    propertiesMap = {},
    xyz,
    zoneType,
  } = selectedZone;
  const { description = "" } = propertiesMap;

  useEffect(() => {}, [selectedZone]);

  return (
    (<Grid container spacing={3}>
      <Grid size={12}>
        {" "}
        <Typography component={"h1"} variant="h5">
          {name}
          {facility?.name ? ` | ${facility.name}` : ""}
        </Typography>
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 4
        }}>
        <strong>Abbreviation</strong> <br />
        {abbreviation || "None provided"}
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 4
        }}>
        <strong>Description</strong> <br />
        {description || "None provided"}
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 4
        }}>
        <strong>Floor</strong> <br />
        {floor || "None provided"}
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 4
        }}>
        <strong>Category</strong> <br />
        {category || "None provided"}
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 4
        }}>
        <strong>Zone Type</strong> <br />
        {zoneType || "None provided"}
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 4
        }}>
        <strong>Parent Zone</strong> <br />
        {zonesMap[parentId]?.name || "None provided"}
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 4
        }}>
        <strong>Location (X, Y, Z)</strong> <br />
        {xyz?.x && xyz?.y && xyz?.z ? `${xyz?.x}, ${xyz?.y}` : "None provided"}
      </Grid>
    </Grid>)
  );
}

export default Information;
